var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 49,
    viewBox: "0 0 139 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1290_5615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1832 21.4586C73.1955 21.2594 73.2004 21.0602 73.2004 20.8585C73.2004 14.2431 67.8343 8.87695 61.2189 8.87695C54.6034 8.87695 49.2373 14.2431 49.2373 20.8585C49.2373 27.4739 54.601 32.8401 61.2189 32.8401C67.0154 32.8401 71.8527 28.7257 72.9619 23.2538H66.0489C65.1684 25.0294 63.3363 26.2492 61.2189 26.2492C58.4448 26.2492 56.1577 24.1515 55.8601 21.4561H73.1832V21.4586ZM61.2164 15.4678C63.6535 15.4678 65.7169 17.0885 66.3809 19.3141H56.0519C56.7159 17.0909 58.7743 15.4678 61.2164 15.4678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.953 25.3943V9.35742H122.959V32.359H138.457V25.3919H129.956L129.953 25.3943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0971 9.3916L84.8598 21.8748L80.5757 9.3916H72.9053L81.4709 32.4227H88.2511L96.6348 9.3916H89.0996H89.0971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.529 8.87695C101.914 8.87695 96.5479 14.2431 96.5479 20.8585C96.5479 27.4739 101.914 32.8401 108.529 32.8401C115.145 32.8401 120.511 27.4764 120.511 20.8585C120.511 14.2406 115.147 8.87695 108.529 8.87695ZM108.529 26.2517C105.554 26.2517 103.136 23.8391 103.136 20.8585C103.136 17.8779 105.551 15.4653 108.529 15.4653C111.508 15.4653 113.923 17.8803 113.923 20.8585C113.923 23.8367 111.51 26.2517 108.529 26.2517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6534 45.2917L50.3682 40.5674C50.3485 40.3436 50.2845 40.1346 50.1862 39.9477L33.6205 6.62215L33.6082 6.63691C32.7278 4.66211 30.844 3.24066 28.5938 3.02178C27.6199 2.92833 26.6436 2.84717 25.6673 2.77831C25.5836 1.61508 24.6147 0.695312 23.4293 0.695312H11.7527C10.5674 0.695312 9.5984 1.61508 9.51478 2.77831C8.54583 2.84717 7.57688 2.92587 6.60793 3.01932C3.66419 3.30214 1.34264 5.64582 1.08441 8.58956L0.0244677 26.1168C-0.0443918 27.2431 0.0293862 28.3744 0.280232 29.4737C1.26886 33.8118 4.62084 37.2499 8.9098 38.3639L43.2412 48.4863C43.3863 48.5428 43.5388 48.5846 43.6937 48.6191L43.7306 48.6289C43.9421 48.6707 44.1585 48.6953 44.3823 48.6953H47.4441C48.9762 48.6953 50.2575 47.6255 50.5846 46.1942C50.651 45.8967 50.6731 45.5917 50.6534 45.2892V45.2917Z",
    fill: "url(#paint0_linear_1290_5615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40515 25.3201C3.8263 25.3201 2.56469 24.0019 2.63355 22.4231L3.17951 10.0037C3.36149 8.08552 4.87886 6.56077 6.79955 6.37633C10.3704 6.03203 14.0027 5.85742 17.5908 5.85742C21.1789 5.85742 24.8088 6.03203 28.3796 6.37633C30.3003 6.56077 31.8201 8.08552 31.9997 10.0037L32.5456 22.4231C32.6145 24.0019 31.3529 25.3201 29.774 25.3201H5.40515Z",
    fill: "#290256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0775 4.98178C19.4156 4.71864 15.7488 4.71864 12.1042 4.97686C11.8066 4.999 11.546 4.7752 11.5214 4.47763C11.4968 4.18006 11.723 3.91938 12.0255 3.89725C15.7218 3.6341 19.4427 3.6341 23.1537 3.8997C23.4587 3.92184 23.6849 4.18252 23.6628 4.48009C23.6382 4.77766 23.3775 4.999 23.0775 4.97932V4.98178Z",
    fill: "#FFA51E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50302 32.6213C6.47551 32.6213 7.26386 31.8329 7.26386 30.8604C7.26386 29.888 6.47551 29.0996 5.50302 29.0996C4.53054 29.0996 3.74219 29.888 3.74219 30.8604C3.74219 31.8329 4.53054 32.6213 5.50302 32.6213Z",
    fill: "#FFA51E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6759 32.6359C30.6484 32.6359 31.4367 31.8476 31.4367 30.8751C31.4367 29.9026 30.6484 29.1143 29.6759 29.1143C28.7034 29.1143 27.915 29.9026 27.915 30.8751C27.915 31.8476 28.7034 32.6359 29.6759 32.6359Z",
    fill: "#FFA51E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2423 23.7784C14.751 23.7784 12.7246 21.752 12.7246 19.2607H14.7633C14.7633 20.6281 15.8749 21.7397 17.2423 21.7397C18.6096 21.7397 19.7212 20.6281 19.7212 19.2607H21.76C21.76 21.752 19.7335 23.7784 17.2423 23.7784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4346 14.9447C9.34516 14.9447 8.44999 14.1159 8.34424 13.0535H15.8081C15.6876 10.8205 13.8382 9.0498 11.5757 9.0498C9.31319 9.0498 7.33594 10.9484 7.33594 13.2896C7.33594 15.6308 9.23449 17.5294 11.5757 17.5294C13.7817 17.5294 15.5942 15.8423 15.7934 13.6904H12.3602C12.0356 14.4307 11.2929 14.9471 10.4346 14.9471V14.9447ZM10.4346 10.7369C11.5265 10.7369 12.4242 11.5681 12.5275 12.6305H8.34178C8.44753 11.5681 9.34516 10.7369 10.4322 10.7369H10.4346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6646 9.04688C20.3234 9.04688 18.4248 10.9454 18.4248 13.2867C18.4248 15.6279 20.3234 17.5264 22.6646 17.5264C25.0058 17.5264 26.9044 15.6279 26.9044 13.2867C26.9044 10.9454 25.0058 9.04688 22.6646 9.04688ZM21.6243 14.9442C20.4635 14.9442 19.5216 14.0023 19.5216 12.8415C19.5216 11.6808 20.4635 10.7364 21.6243 10.7364C22.7851 10.7364 23.7294 11.6783 23.7294 12.8415C23.7294 14.0048 22.7875 14.9442 21.6243 14.9442Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1290_5615",
    x1: 27.8831,
    y1: 29.122,
    x2: 48.7573,
    y2: 48.1617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F96619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F46324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E75C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D15171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#B442B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3DCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1290_5615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.457,
    height: 48,
    fill: "white",
    transform: "translate(0 0.698242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.c68c064a3ffde06fed9eea4e828c49b0.svg";
export { ForwardRef as ReactComponent };